<template>
  <div id="app">
    <div v-show="isLogin">
      <el-row class="container">
        <el-col :span="24" class="header">
          <el-col :span="10" class="logo logo-width">
            shchess后台管理系统
          </el-col>
          <el-col :span="10">
            <div class="tools" @click.prevent="collapse">
              <i class="fa fa-align-justify"></i>
            </div>
          </el-col>
          <el-col :span="4" class="userinfo">
            <span class="el-dropdown-link userinfo-inner"> <img src="./assets/timg.jpg" />你好，管理员</span><el-button @click="logout">退出登录</el-button>
          </el-col>
        </el-col>
        <el-col :span="24" class="main">
          <aside class="menu-expanded">
            <el-menu :default-active="$route.path" class="el-menu-vertical-demo" :router="true" unique-opened style="height: 100%">
              <el-menu-item index="/"><i class="el-icon-menu"></i>首页</el-menu-item>
<!--              <el-submenu index="/region">-->
<!--                <template slot="title"><i class="el-icon-setting"></i>比赛管理</template>-->
<!--                  <el-menu-item index="/contest">比赛列表</el-menu-item>-->
<!--              </el-submenu>-->
              <el-submenu index="order">
                <template slot="title"><i class="el-icon-star-off"></i>订单管理</template>
<!--                <el-menu-item index="/order">订单列表</el-menu-item>-->
                <el-menu-item index="/order2">精英赛报名列表</el-menu-item>
                <el-menu-item index="/cancelorder2">精英赛已取消列表</el-menu-item>
              </el-submenu>
<!--              <el-submenu index="user">-->
<!--                <template slot="title"><i class="el-icon-date"></i>用户管理</template>-->
<!--                <el-menu-item index="/user">用户列表</el-menu-item>-->
<!--              </el-submenu>-->
            </el-menu>


</aside>

          <section class="content-container">
            <router-view></router-view>
          </section>
        </el-col>

      </el-row>

    </div>

    <div  v-show="!isLogin" >
      <div id="mainbg"></div>
      <div id="loginform">
        <h1 style="text-align: center">报名管理后台</h1>
        <h4 style="text-align: right">@shchess.com</h4>
        <el-form :model="account"  label-width="40px" class="demo-ruleForm">
          <el-form-item label="账号" prop="pass" class="loginlabel">
            <el-input type="text" v-model="account.username" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="checkPass" class="loginlabel">
            <el-input type="password" v-model="account.password" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="login">登陆</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
        isLogin:false,
       account: {
        username: '',
        password: '',
      },


    }
  },
  mounted(){
    // this.$http.getData("logout", ()=>{}, ()=>{})

    this.$http.getData('logintest',()=>{
      this.isLogin=true
    },()=>{
      this.isLogin=false
    })
  },
  methods:{
    logout: function () {
        this.$message.success("退出登录成功");
        this.$router.push({ path: '/'})
        this.isLogin=false
      this.$http.getData("logout", ()=>{}, ()=>{})
    },
    login:function () {
        this.$http.postData("login",this.account,
            (data)=>{
                this.$message.success("登录成功");
                this.isLogin=true
            },
            (data)=>{
                this.$message.error(data.message);
            }
        )
   }
  }

}
</script>

<style lang="scss" scoped>


  .demo-ruleForm{
    margin-top: 30px;
  }
  .container{
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;
    .header {
      height: 60px;
      line-height: 60px;
      background: #167cbf;
      color: #fff;

      .userinfo {
        text-align: right;
        padding-right: 35px;
        float: right;
        .userinfo-inner {
          cursor: pointer;
          color:#fff;
          img {
            width: 40px;
            height: 40px;
            border-radius: 20px;
            margin: 10px 0px 10px 10px;
            float: right;
          }
        }
      }
      .logo {
        width:230px;
        height:60px;
        font-size: 22px;
        padding-left:20px;
        padding-right:20px;
        border-color: rgba(238,241,146,0.3);
        border-right-width: 1px;
        border-right-style: solid;
        img {
          width: 40px;
          float: left;
          margin: 10px 10px 10px 18px;
        }
        .txt {
          color:#fff;
        }
      }
    }
    .main{
      display: flex;
      //background: #324057;
      position: absolute;
      top: 60px;
      bottom: 0px;
      overflow: hidden;
      .menu-expanded{
        flex:0 0 230px;
        width: 230px;
      }
      .content-container {
        flex:1;
        overflow-y: scroll;
        padding: 20px;
        .breadcrumb-container {
          //margin-bottom: 15px;
          .title {
            width: 200px;
            float: left;
            color: #475669;
          }
          .breadcrumb-inner {
            float: right;
          }
        }
        .content-wrapper {
          background-color: #fff;
          box-sizing: border-box;
        }
      }
    }
  }


</style>

<style>
  body{
    margin: 0;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    margin: 0;
  }
  #mainbg {
    background: url('assets/bg1.jpg');
    position:absolute;
    width:100%;
    height:100%;
    display: flex;
    justify-content: center;
  }
  #loginform{
    position: absolute;
    z-index: 9999;
    border: 1px white groove;
    padding: 50px;
    color: white;
    left: 50%;
    margin-left: -170px;
    top:20%;
  }
  .loginlabel label{
    color: white;
  }
</style>
